const UTM_STORAGE_KEY = "eb5_utm_params";
const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const;
// Task #2973 — paid-social click identifiers. Captured alongside UTM so a
// later "Schedule a Call" booking can fire a deduplicated server-side
// conversion (Meta + LinkedIn Conversions API). `li_fat_id` is LinkedIn's
// first-party click id; `fbclid` is Meta's; `gclid` is Google Ads'.
const CLICK_ID_PARAMS = ["fbclid", "li_fat_id", "gclid"] as const;

export interface UtmData {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
  fbclid?: string;
  liFatId?: string;
  gclid?: string;
  referrer?: string;
  landingPage?: string;
}

function captureFromUrl(): void {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);
  const hasUtm = UTM_PARAMS.some((p) => params.has(p));
  const hasClickId = CLICK_ID_PARAMS.some((p) => params.has(p));

  if (hasUtm || hasClickId) {
    const data: Record<string, string> = {};
    [...UTM_PARAMS, ...CLICK_ID_PARAMS].forEach((p) => {
      const val = params.get(p);
      if (val) data[p] = val;
    });
    data.landing_page = window.location.pathname;
    data.referrer = document.referrer || "";
    data.captured_at = new Date().toISOString();
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(data));
  } else if (!sessionStorage.getItem(UTM_STORAGE_KEY)) {
    const data: Record<string, string> = {
      landing_page: window.location.pathname,
      referrer: document.referrer || "",
      captured_at: new Date().toISOString(),
    };
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(data));
  }
}

captureFromUrl();

export function getUtmData(): UtmData {
  try {
    const raw = sessionStorage.getItem(UTM_STORAGE_KEY);
    if (!raw) return {};
    const data = JSON.parse(raw);
    return {
      utmSource: data.utm_source || undefined,
      utmMedium: data.utm_medium || undefined,
      utmCampaign: data.utm_campaign || undefined,
      utmTerm: data.utm_term || undefined,
      utmContent: data.utm_content || undefined,
      fbclid: data.fbclid || undefined,
      liFatId: data.li_fat_id || undefined,
      gclid: data.gclid || undefined,
      referrer: data.referrer || undefined,
      landingPage: data.landing_page || undefined,
    };
  } catch {
    return {};
  }
}

export function clearUtmData(): void {
  sessionStorage.removeItem(UTM_STORAGE_KEY);
}
